var cw_store = cw_storage();

function cw_storage(){
  var cw_store = {}
  cw_store.availability = function(key){
    try{
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return true;
    }catch(error){
      return false;
    }
  }
  cw_store.enabled = cw_store.availability('cw_store_test');
  cw_store.set = function(key, value){
    if(cw_store.enabled){
      localStorage.setItem(key, value);
    }
  }
  cw_store.set_session = function(key, value){
    if(cw_store.enabled){
      sessionStorage.setItem(key, value);
    }
  }
  cw_store.get = function(key){
    if(cw_store.enabled && localStorage.getItem(key)){
      var value = localStorage.getItem(key).replace(/"/g, '');
    }else{
      var value = null;
    }
    if (value === 'null'){
      value = null;
    }
    return value;
  }
  cw_store.get_session = function(key){
    if(cw_store.enabled && sessionStorage.getItem(key)){
      var value = sessionStorage.getItem(key);
    }else{
      var value = null;
    }
    return value;
  }
  cw_store.remove = function(key){
    localStorage.removeItem(key);
  }
  cw_store.remove_session = function(key){
    sessionStorage.removeItem(key);
  }
  cw_store.removeAll = function(){
    localStorage.clear();
  }
  cw_store.set_json = function(key, value) {
    cw_store.set(key, JSON.stringify(value));
  }
  cw_store.get_json = function(key) {
    if (cw_store.enabled) {
      return JSON.parse(localStorage.getItem(key));
    }
  }
  return cw_store;
}
